import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

class SlackFirstStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  render() {
    const { className } = this.props

    return (
      <div className={className}>
        <div className="start-title">Start Integration</div>
        <Button
          text="Open WebHooks App"
          secondary
          onClick={() =>
            window.open(
              'https://ironscales.slack.com/apps/A0F7XDUAZ-incoming-webhooks?utm_source=in-prod&utm_medium=inprod-btn_app_install-index-click'
            )
          }
          className="webhooks-button"
          id="slack-openWebhooks"
        />
        <img
          src="/static/webapp/images/settings/slack-first-screenshot.png"
          className="screenshot"
        />
        <div className="actions-container">
          <div className="number-indication">1</div>
          <span className="text-indication">Click on “Add to Slack”</span>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="slack-backButton"
          />
          <Button
            text="Next Step"
            onClick={() => this.handleStepRedirect(1)}
            className="sml"
            id="slack-nextButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(SlackFirstStep)`
  .start-title {
    font-weight: bold;
    font-size: 16px;
  }
  .webhooks-button {
    margin: 20px 0 30px 0;
  }
`
